import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import Riwayat from 'app/KinerjaRiwayat/pages/Riwayat'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { RiwayatV2, ROLES_FILTER } from 'app/KinerjaRiwayat/pages/RiwayatV2'
import { parseQuery } from 'utils/router'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { RoleFilterType } from 'app/KinerjaRiwayat/pages/RiwayatV2'
import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

type PageParams = { year: number; role?: RoleFilterType }

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<PageParams>> => {
    // Riwayat toggle must be enabled to access this page
    const enabled = toggle?.['kinerja-riwayat-enabled'] || false

    // Get year params with default of current year
    let year = Number(parseQuery<string>(context?.query?.year, 'string'))
    if (Number.isNaN(year)) {
      year = new Date().getFullYear()
    }

    // Get role filter params with default value of 'ALL'
    let role = parseQuery<RoleFilterType>(context?.query?.role, 'string')
    if (!ROLES_FILTER.some(({ value }) => value === role)) {
      role = 'ALL'
    }

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return { props: { year, role } }
  },
})

const Page: KinerjaApp = ({ year, role }: PageProps & PageParams) => {
  if (year >= 2025) {
    return <RiwayatV2 year={year} role={role} />
  }

  return <Riwayat />
}
Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Riwayat',
}

export default Page
